/**
 * The press on a touch screen (row 144). WebKit — Safari and the iOS app's
 * WKWebView — gives a touched element `:active` only when the page listens
 * for touches; without a listener a tap shows the system's grey tap highlight
 * and none of the design system's pressed states (checked on iOS 26.5: no
 * listener, no `:active`; one passive listener on the document, `:active` on
 * every press). The listener does nothing and never blocks scrolling. The host
 * calls this once — web's main.ts, the subscription site, the specimen pages;
 * a second call, from another package's copy, is a no-op.
 */
const ENABLED = Symbol.for("tredco.press-feedback")

export function enablePressFeedback(): void {
  if (typeof document === "undefined") {
    return
  }
  const host = globalThis as { [ENABLED]?: true }
  if (host[ENABLED]) {
    return
  }
  host[ENABLED] = true
  document.addEventListener("touchstart", () => {}, { passive: true })
}
